import React, { useEffect, useRef, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HighlightsItem from '../../../../../Homepage/Highlights/HighlightsItem';

import icon1 from "../../../../../../assets/images/satellite/icon_tecnico.png";
import icon2 from "../../../../../../assets/images/satellite/icon_consultoria.png";
import icon3 from "../../../../../../assets/images/satellite/icon_outsourcing.png";

import { Trans } from 'react-i18next';


const OutsourcingPilar3 = props => {

    const [inView, setInView] = useState(false);
    const ref = useRef(null);
    const checkInView = e => {
        if (!ref.current || (!e.target.scrollingElement && !e.target.documentElement)) {
            return;
        }
        let scrollingElement = e.target.scrollingElement ? e.target.scrollingElement : e.target.documentElement;

        let top = ref.current.offsetTop;
        const bottom = ref.current.clientHeight + top;
        top -= scrollingElement.clientHeight;
        const inV = top + 15 < scrollingElement.scrollTop && bottom > scrollingElement.scrollTop;
        if (inView !== inV) {
            setInView(inV);
        }
    }
    useEffect(() => {
        document.addEventListener('scroll', checkInView, true);

        return () => {
            document.removeEventListener('scroll', checkInView, true);

        }
    });

    return (

        <section id="outsourcing-pilar-section3" className="my pt-5">
            <div className='blue-shape'></div>
            <Container>
                <div className="title-triangle top-md fw-600"></div>
                <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingPilar:section-3.title')}</h2>
                <p className='mb-5'>{props.t('services:outsourcingPilar:section-3.text')}</p>
                {/* Text content */}
                <div className='highlights my mb-3 text-md-center'>
                    <Row className='justify-content-around'>
                        <HighlightsItem image={icon1} inView={inView} custom title={props.t('services:outsourcingPilar:section-3.1.title')} text={props.t('services:outsourcingPilar:section-3.1.text')} />
                        <HighlightsItem image={icon2} inView={inView} custom title={props.t('services:outsourcingPilar:section-3.2.title')} text={props.t('services:outsourcingPilar:section-3.2.text')} />
                        <HighlightsItem image={icon3} inView={inView} custom title={props.t('services:outsourcingPilar:section-3.3.title')} text={props.t('services:outsourcingPilar:section-3.3.text')} />
                    </Row>
                </div>
                {/* Text content */}
                <div>
                    <div className='d-flex align-items-center mb-4'>
                        <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-3.4.title')}</h3>
                    </div>
                    <ul className='m-0'>
                        {props.t('services:outsourcingPilar:section-3.4.list', { returnObjects: true }).map((item, index) => (
                            <li key={index}><p className='m-0'><Trans i18nKey={item} components={{ b: <b></b> }} /></p></li>
                        ))}
                    </ul>
                </div>
            </Container>
        </section>
    )
};


export default OutsourcingPilar3;